import * as React from 'react'
import { Link } from 'react-router-dom'
import {
  featuresPath,
  pricingPath,
  aboutPath,
  blogPath,
  contactPath,
  privacyPath,
  termsPath,
  integrationsPath,
  securityPath,
  caseStudiesPath,
  changelogPath,
} from '@logic'
import { FooterContainer, FooterLinkColumn, FooterLink } from '../styles/marketing.styles'

const footerColumns = [
  {
    title: 'Product',
    links: [
      { to: featuresPath, label: 'Features' },
      { to: pricingPath, label: 'Pricing' },
      { to: integrationsPath, label: 'Integrations' },
      { to: securityPath, label: 'Security' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: aboutPath, label: 'About' },
      { to: blogPath, label: 'Blog' },
      { to: caseStudiesPath, label: 'Case Studies' },
      { to: changelogPath, label: 'Changelog' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: privacyPath, label: 'Privacy' },
      { to: termsPath, label: 'Terms' },
      { to: contactPath, label: 'Contact' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { href: 'https://docs.equa.cc', label: 'Documentation' },
      { href: 'https://api.equa.cc', label: 'API' },
      { href: '#', label: 'Status' },
    ],
  },
]

export const MarketingFooter: React.FC = () => (
  <FooterContainer>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem', marginBottom: '2rem', maxWidth: 1200, margin: '0 auto 2rem' }}>
      {footerColumns.map((col) => (
        <FooterLinkColumn key={col.title}>
          <strong style={{ marginBottom: '0.5rem', display: 'block' }}>{col.title}</strong>
          {col.links.map((link) =>
            'to' in link ? (
              <FooterLink as={Link} to={link.to} key={link.label}>
                {link.label}
              </FooterLink>
            ) : (
              <FooterLink href={link.href} target="_blank" rel="noopener noreferrer" key={link.label}>
                {link.label}
              </FooterLink>
            )
          )}
        </FooterLinkColumn>
      ))}
    </div>
    <div style={{ textAlign: 'center', fontSize: '0.875rem', opacity: 0.9 }}>
      &copy; 2026 Equa. All rights reserved. &middot; support@equa.cc
    </div>
  </FooterContainer>
)
